module.exports = __webpack_public_path__ + "static/media/MG.43bcb800.png";